import React, { Component } from 'react';
import { connect } from 'react-redux';
import { openCartModal, openUpgradeFlowModal } from '../modules/active_modal';
import CommerceBarItem from './CommerceBarItem.jsx';
import EnrollPromo from './EnrollPromo.jsx';
import { navigate } from '../modules/high_level_actions';
import HeroesCommerceBar from './HeroesCommerceBar.jsx';

export class EnrollCommerceBar extends Component {

  constructor(props) {
    super(props);
  }

  dvdSpecialClick(){
    if(this.props.store.hero_link_loggedout){
      let evt = {
        currentTarget: { pathname: this.props.store.hero_link_loggedout },
        preventDefault: () => {}
      };
      this.props.dispatch(navigate(evt));
    }
  }

  render() {

    let {dispatch, second_book, store} = this.props;
    // Define CommerceBarItems and button text. Begin by assuming user is not logged in.
    const itemSharedProps = { status            : this.props.customer.status };

    let oItemOne   = <CommerceBarItem {...itemSharedProps} product={this.props.computedCart.items[0]} i={0} tempPrice ={'$' + second_book} />;
    let oItemTwo   = <CommerceBarItem {...itemSharedProps} product={this.props.computedCart.items[1]} i={1} tempPrice ={'$' + second_book} />;

    let bButtonDisabled = false;
    if (!this.props.customer.id && !this.props.computedCart.items[0] && !this.props.computedCart.items[1]) {
      bButtonDisabled = true;
    }

    let featured = this.props.enrollFeatured || this.props.featured,
        onFeatured = this.props.path === '/';

    // Set conditional CSS classNames and display text
    //@TODO condense all the checks for which section is active!!!
    let nCartSubTotal      = this.props.computedCart.subtotal;
    let sButtonText        = this.props.upgradeStatus ? 'Upgrade Now' : 'Join Now';
    let sButtonFunction    = this.props.upgradeStatus ? openUpgradeFlowModal : openCartModal ;

    if (['CRS','SFC'].includes(this.props.store.tla)) {
      bButtonDisabled = true;
    }

    // FINALLY we can return elements
    return (
       <div className="commerce-bar enrollment-commerce">
        <div className="half-col left active" onClick={this.dvdSpecialClick.bind(this)}>
          <EnrollPromo />
        </div>
        <div className="half-col right active">
          <div className="inner-wrapper left">
            <h6 className="header-link">
              My Box
            </h6>
            <div className="center">
              <div className="cart-items-wrapper">
                {oItemOne}
              </div>
              <div className="cart-items-wrapper">
                {oItemTwo}
              </div>
              <div className="checkout-action-wrapper">
                <button
                  className = "btn-primary checkout"
                  onClick   = {() => dispatch( sButtonFunction() )}
                  disabled  = {bButtonDisabled}
                >
                  <span className="no-wrap" style={{textDecoration: ['CRS','SFC'].includes(this.props.store.tla)  ? 'line-through': 'none'}} >{sButtonText}</span>
                  <br />
                  ${nCartSubTotal.toFixed(2)}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="commerce-bar-mobile">
          <div className="fs-item-wrapper-mobile">
            {oItemOne}
          </div>
          <div className="cart-items-wrapper-mobile">
            {oItemTwo}
          </div>
          <button
              className = "btn-primary checkout"
              onClick   = {() => dispatch( sButtonFunction() )}
              disabled  = {bButtonDisabled}
            >
              {sButtonText}
            </button>
        </div>
      </div>
    );
  }
};

EnrollCommerceBar.defaultProps = {
  path: '/',
  featured: [],
  customer: {}
};

function mapStateToProps(state){
    return {
      'path': state.path,
      'store': state.store,
      'featured': state.featured,
      'second_book': state.store.second_book,
      'customer': state.customer,
      'computedCart': state.computedCart,
      'upgradeStatus': state.upgradeStatus
    };
}

export default connect(mapStateToProps)(EnrollCommerceBar);



// WEBPACK FOOTER //
// ./src/components/EnrollCommerceBar.jsx